import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SecurityProvider } from '../../context/security-context';
import SecurityDetails from './security-details/security-details';
import SecurityList from './security-list/security-list';

const Securities = () => {
  console.log('Securities: rendering');

  return (
    <Routes>
      <Route index element={<SecurityList />} />
      <Route
        path=":securityId"
        element={
          <SecurityProvider>
            <SecurityDetails />
          </SecurityProvider>
        }
      />
    </Routes>
  );
};

export default Securities;